import React from 'react'

const UseCaseCardGrid = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="py-8 bg-neutral">
      <div className="mx-auto grid w-full max-w-5xl grid-cols-1 gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:max-w-6xl xl:max-w-7xl xl:grid-cols-4">
        {children}
      </div>
    </div>
  )
}

export default UseCaseCardGrid
